// extracted by mini-css-extract-plugin
module.exports = {"page_header":"page-header_page_header__2FeA9","no_margin":"page-header_no_margin__1mQMd"};